module.exports = __webpack_public_path__ + "static/media/vegitables_14.f8b60440.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_14.csv
// module id = 596
// module chunks = 0